// File: cgp-sidenav.module.ts
// Author: Joseph M Diaz
// Date: 5/10/2017
// Desc: Sidenav component. Items are loaded fromt he config file.
// Other Contributors:

import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatExpansionModule } from '@angular/material/expansion';

import { CgpSidenavComponent } from "./cgp-sidenav.component";
import { CgpSidenavItemComponent } from "./cgp-sidenav-item/cgp-sidenav-item.component";
import { CgpSidenavService } from "./cgp-sidenav.service";

@NgModule({
    imports: [
        CommonModule,
        MatExpansionModule
    ],
    exports: [
        CgpSidenavComponent
    ],
    declarations: [
        CgpSidenavComponent,
        CgpSidenavItemComponent
    ],
    providers: [
        CgpSidenavService
    ]
})
export class CgpSidenavModule {}